import { render, staticRenderFns } from "./intentionLibrary.vue?vue&type=template&id=63a21500&scoped=true"
import script from "./intentionLibrary.vue?vue&type=script&lang=js"
export * from "./intentionLibrary.vue?vue&type=script&lang=js"
import style0 from "./intentionLibrary.vue?vue&type=style&index=0&id=63a21500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a21500",
  null
  
)

export default component.exports